import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/posts",
    name: "Posts",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Posts" */ "../views/Posts.vue"),
  },
  {
    path: "/my-account",
    name: "My Account",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "MyAccount" */ "../views/My-Account.vue"),
  },
  {
    path: "/contact-forms",
    name: "ContactForms",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ContactForms" */ "../views/Contact-Forms.vue"),
  },
  {
    path: "/portfolio",
    name: "Portfolio",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Portfolio" */ "../views/Portfolio.vue"),
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Login.vue"),
  },
  {
    path: "/services",
    name: "Services",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Services" */ "../views/Services.vue"),
  },
  {
    path: "/onboarding-forms",
    name: "OnboardingForms",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "OnboardingForms" */ "../views/Onboarding-Forms.vue"),
  },
  {
    path: "/onboarding-forms/website-design/:id",
    name: "WebsiteDesignIntakeFormSubmission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "WebsiteDesignIntakeFormSubmission" */ "../views/onboarding-forms/website-forms.vue")
  },
  {
    path: "/onboarding-forms/social-media/:id",
    name: "SocialMediaIntakeFormSubmission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "WebsiteDesignIntakeFormSubmission" */ "../views/onboarding-forms/social-media-forms.vue")
  },
  {
    path: "/onboarding-forms/app-development/:id",
    name: "AppDevIntakeFormSubmission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "AppDevIntakeFormSubmission" */ "../views/onboarding-forms/app-dev-forms.vue")
  },
  // Website Design & Layout
  {
    path: "/website-design-and-layout/homepage",
    name: "homepageDesign",
    component: () =>
      import(/* webpackChunkName: "HomepageDesign" */ "../views/website-design-and-layout/Homepage.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
